import { Group } from "./group.model";

export class GroupMapper {
  public static map(groupData: any): Group {
    return new Group(+groupData.id, groupData.name);
  }
}
